import React, {useMemo} from 'react'
import Tr from 'translations/Translations';
import {withRouter} from "react-router";
import RouterPath from 'libs/RouterPath';
import StageBarCommon, {createStageBarElement} from "components/complex/stagebar/StageBarCommon";
import {PurchasingGroupStatus} from "../../constants/PurchasingGroupStatus";
import PropTypes from "prop-types";
import {PurchasingGroupRole} from "../constants/PurchasingGroupRole";

const rps = RouterPath.purchasingGroup;

function PurchaserGroupStageBar(
    {
        match,
        location,
        purchaserGroupHeader
    }) {
    const groupId = match.params.id;
    const stage = match.params.stage;

    const stageBarElements = useMemo(() => {
        const elems = [];

        elems[0] = createStageBarElement(
            Tr('purchase_group_stage_1'),
            groupId ? RouterPath.createPath(rps.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {id: groupId, stage: 1}) : undefined,
            stage === "1",
            false
        )
        elems[1] = createStageBarElement(
            Tr('purchase_group_stage_2'),
            groupId && purchaserGroupHeader.status !== PurchasingGroupStatus.PREPARING && (purchaserGroupHeader.userRole !== PurchasingGroupRole.MEMBER || purchaserGroupHeader.lastStageStarted >= 5) ? RouterPath.createPath(rps.MP_PURCHASING_GROUP_GROUP_ID_STAGE_NR, {id: groupId, stage: 2}) : undefined,
            stage === "2",
            false
        )
        return elems;


    }, [stage, groupId, purchaserGroupHeader])

    return (
        <StageBarCommon elements={stageBarElements}/>
    )
}

PurchaserGroupStageBar.propTypes = {
    purchaserGroupHeader: PropTypes.object.isRequired
}

export default withRouter(PurchaserGroupStageBar);